import React from "react";
import { NavLink } from "react-router-dom";
import { Home, Search, BookOpen, Building2, User } from "lucide-react";
import { useT } from "@/lib/i18n";
import { useAuth } from "@/context/AuthContext";

export function MobileNav() {
  const { t } = useT();
  const { user } = useAuth();
  const accountPath = user ? (user.role === "admin" ? "/admin" : user.role === "csr_manager" ? "/csr/workspace" : user.role === "ngo_admin" ? "/ngo/dashboard" : "/login") : "/login";
  const items = [
    { to: "/", icon: Home, label: "Home", exact: true },
    { to: "/discover", icon: Search, label: t("common.search") },
    { to: "/stories", icon: BookOpen, label: t("nav.stories") },
    { to: "/for-csr", icon: Building2, label: "CSR" },
    { to: accountPath, icon: User, label: user ? "Me" : t("common.login") },
  ];
  return (
    <nav className="md:hidden fixed bottom-0 inset-x-0 z-50 bg-white border-t border-stone-200 grid grid-cols-5 shadow-[0_-2px_10px_rgba(0,0,0,0.06)]" data-testid="mobile-bottom-nav">
      {items.map((it) => (
        <NavLink key={it.to + it.label} to={it.to} end={it.exact}
          className={({ isActive }) => `flex flex-col items-center justify-center gap-0.5 py-2 text-[11px] font-medium transition-colors ${isActive ? "text-terracotta" : "text-stone-500"}`}>
          <it.icon size={20} />
          <span className="truncate max-w-full px-0.5">{it.label}</span>
        </NavLink>
      ))}
    </nav>
  );
}

export default MobileNav;
